/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedFieldBoolean } from './ParsedFieldBoolean';
import {
    ParsedFieldBooleanFromJSON,
    ParsedFieldBooleanFromJSONTyped,
    ParsedFieldBooleanToJSON,
} from './ParsedFieldBoolean';
import type { ParsedFieldString } from './ParsedFieldString';
import {
    ParsedFieldStringFromJSON,
    ParsedFieldStringFromJSONTyped,
    ParsedFieldStringToJSON,
} from './ParsedFieldString';

/**
 * 
 * @export
 * @interface PartialProduct
 */
export interface PartialProduct {
    /**
     * 
     * @type {string}
     * @memberof PartialProduct
     */
    id?: string;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialProduct
     */
    clientReference?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialProduct
     */
    fullName?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialProduct
     */
    abbreviatedName?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldBoolean}
     * @memberof PartialProduct
     */
    isActive?: ParsedFieldBoolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialProduct
     */
    hasParseErrors?: boolean;
}

/**
 * Check if a given object implements the PartialProduct interface.
 */
export function instanceOfPartialProduct(value: object): value is PartialProduct {
    return true;
}

export function PartialProductFromJSON(json: any): PartialProduct {
    return PartialProductFromJSONTyped(json, false);
}

export function PartialProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'clientReference': json['clientReference'] == null ? undefined : ParsedFieldStringFromJSON(json['clientReference']),
        'fullName': json['fullName'] == null ? undefined : ParsedFieldStringFromJSON(json['fullName']),
        'abbreviatedName': json['abbreviatedName'] == null ? undefined : ParsedFieldStringFromJSON(json['abbreviatedName']),
        'isActive': json['isActive'] == null ? undefined : ParsedFieldBooleanFromJSON(json['isActive']),
        'hasParseErrors': json['hasParseErrors'] == null ? undefined : json['hasParseErrors'],
    };
}

export function PartialProductToJSON(value?: PartialProduct | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'clientReference': ParsedFieldStringToJSON(value['clientReference']),
        'fullName': ParsedFieldStringToJSON(value['fullName']),
        'abbreviatedName': ParsedFieldStringToJSON(value['abbreviatedName']),
        'isActive': ParsedFieldBooleanToJSON(value['isActive']),
        'hasParseErrors': value['hasParseErrors'],
    };
}

